import AssignOvertimePopup from '@/views/time-tracker/overtime/AssignOvertimePopup.vue';
import AddOvertimePopup from '../../../views/time-tracker/overtime/AddOvertimePopup.vue';
import EditOvertimeStartPopup from '../../../views/time-tracker/overtime/EditOvertimeStartPopup.vue';
import OvertimePopup from '../../../views/time-tracker/overtime/OvertimePopup.vue';
import {Popup} from '../../popup';

export const OVERTIME_STATE_ACCEPT = 1;

export const OVERTIME_STATE_REJECT = 2;

export const OVERTIME_STATE_REVOKE = 3;

export const OVERTIME_REVOKE_STATE_NONE = 0;

export const OVERTIME_REVOKE_STATE_WAIT = 1;

export const OVERTIME_REVOKE_STATE_ACCEPTED = 2;

export const OVERTIME_REVOKE_STATE_DECLINED = 3;

export function editOvertimeRequest(id: number, request: boolean = false, type: Nullable<0|1> = null, actionType: Nullable<number> = null, typeChangeable: boolean = false)
{
    let subject = 'Stundenantrag';

    if (type !== null)
    {
        subject = ['Überstundenantrag', 'Stundenabbauantrag'][type] ?? subject;
    }

    const popup = new Popup({
        title: id ? `${subject} bearbeiten` : `${subject} stellen`,
        titleIcon: 'assignment',
        size: 'small',
        component: OvertimePopup,
        componentProps: {
            id,
            request,
            type,
            actionType,
            typeChangeable,
        }
    });

    popup.open();

    return popup;
}

export function editOvertimeChangeRequest(id: number, request: boolean = false, type: Nullable<0|1> = null, actionType: Nullable<number> = null)
{
    const popup = new Popup({
        title: request ? 'Änderung für einen Stundenantrag beantragen' : 'Änderungsantrag bearbeiten',
        titleIcon: 'edit',
        size: 'small',
        component: OvertimePopup,
        componentProps: {
            id,
            request,
            change: true,
            type,
            actionType
        }
    });

    popup.open();

    return popup;
}

export function editOvertimeRevokeRequest(id: number, request: boolean = false, type: Nullable<0|1> = null, actionType: Nullable<number> = null)
{
    const popup = new Popup({
        title: request ? 'Stundenantrag zurückziehen' : 'Rückzug bearbeiten',
        titleIcon: 'undo',
        size: 'small',
        component: OvertimePopup,
        componentProps: {
            id,
            request,
            revoke: true,
            type,
            actionType
        }
    });

    popup.open();

    return popup;
}

export function editStart(employee: number = 0)
{
    let popup = new Popup({
        title: 'Startwert bearbeiten',
        titleIcon: 'edit',
        size: 'small',
        component: EditOvertimeStartPopup,
        componentProps: {
            id: employee,
        }
    });

    popup.open();

    return popup;
}

export function addOvertime(employee: number)
{
    return new Promise((resolve, reject) => {
        let popup = new Popup({
            title: 'Stunden bearbeiten',
            titleIcon: 'edit',
            size: 'small',
            component: AddOvertimePopup,
            componentProps: {
                id: employee,
            },
            events: {
                saved: resolve,
                onClose: reject,
            },
        });

        popup.open();

        return popup;
    });
}

export function assignOvertime(employee: number)
{
    let popup = new Popup({
        title: 'Stundenabbau anordnen',
        titleIcon: 'edit',
        size: 'small',
        component: AssignOvertimePopup,
        componentProps: {
            id: employee,
        }
    });

    popup.open();

    return popup;
}

export function convertDecimalToTimeFormat(
    value: number,
    {padHours = false}: { padHours?: boolean } = {},
)
{
    const isNegative = value < 0;

    value = Math.abs(value);

    let hours   = Math.floor(value);
    let minutes = Math.round((value - hours) * 60);

    if (minutes === 60)
    {
        hours += 1;
        minutes = 0;
    }

    const hourString   = padHours ? ('0' + hours).slice(-2) : String(hours);
    const minuteString = ('0' + minutes).slice(-2);

    let timeString = `${hourString}:${minuteString}`;

    if (isNegative)
    {
        timeString = '-' + timeString;
    }

    return timeString;
}

export function formatHours(hours: string)
{
    let splitTime = [];

    if (hours === '' || hours === 'null')
    {
        return '';
    }

    if (hours.indexOf(',') === -1 && hours.indexOf('.') === -1 && hours.indexOf(':') === -1)
    {
        return `${hours}h 00min`;
    }

    if (hours.indexOf(',') !== -1)
    {
        splitTime = hours.split(',');
    }
    else if (hours.indexOf('.') !== -1)
    {
        splitTime = hours.split('.');
    }
    else if (hours.indexOf(':') !== -1)
    {
        splitTime = hours.split(':');
        return `${splitTime[0]}h ${splitTime[1]}min`;
    }
    else
    {
        return '';
    }

    if (splitTime.length === 2)
    {
        splitTime[1] = '0.' + splitTime[1];
        return `${splitTime[0]}h ${Math.ceil(parseFloat(splitTime[1]) * 60)}min`;
    }

    return '';
}